import TaxonomyTreeWidget from '../lib/search/TaxonomyTreeWidget.js';

export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        const rootNodeEle = ele.querySelector('[data-tree-node]');
        const widget = new TaxonomyTreeWidget(rootNodeEle);
        ele.widget = widget; // FIXME!!!

        rootNodeEle.addEventListener('change', trackFilterSelection);

        function trackFilterSelection(event) {
            const target = event.target;

            if (target.getAttribute('type') === 'checkbox') {
                if (target.checked) {
                    trackEvent(target);
                }
            } else if (!target.disabled) {
                trackEvent(target);
            }
        }

        function trackEvent(target) {
            trackingservice.trackEventObject({
                analyticsName: `navigation.filter-by-${target.name.replace(
                    /_/g,
                    ''
                )}.click`,
                stringValue: `${target.name}:${target.value}`,
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/taxonomyTree.js